import AxiosInstance from "../../utils/AxiosInstance";
import { WhyusInterface } from "./models/WhyusInterface";

const API_ROUTE = "why_us";

export const getWhyusList = async (params: any) => {
    const prm = new URLSearchParams(params).toString()
    return await AxiosInstance.get(`/${API_ROUTE}?${prm}`);
};

export const getWhyusDetail = async (index: string) => {
    return await AxiosInstance.get(`/${API_ROUTE}/${index}`);
};

export const createWhyus = async (data: WhyusInterface) => {
    const formData = new FormData();
    const keys = Object.keys(data);
    for (var i = 0; i < keys.length; i++) {
        formData.append(keys[i], data[keys[i]]);
    }

    return await AxiosInstance.post(`/${API_ROUTE}`, formData);
};

export const updateWhyus = async (index: string, data: WhyusInterface) => {
    // const formData = new FormData();
    // const keys = Object.keys(data);
    // for (var i = 0; i < keys.length; i++) {
    //     formData.append(keys[i], data[keys[i]]);
    // }

    return await AxiosInstance.post(`/${API_ROUTE}/${index}`, data);
};

export const deleteWhyus = async (index: string) => {
    return await AxiosInstance.delete(`/${API_ROUTE}/${index}`);
};